import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MobileCTA from '../../components/feature/MobileCTA';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  const services = [
    {
      icon: 'ri-paint-brush-line',
      title: 'Interior Painting',
      description: 'Fresh paint makes your home feel new again. We paint living rooms, bedrooms, kitchens, bathrooms, hallways, and any other room in your house.',
      features: ['Walls and ceilings', 'Trim, baseboards, and doors', 'We move and protect your furniture', 'Fill holes and fix cracks', 'Clean, smooth finish', 'Complete cleanup when done'],
      image: 'https://public.readdy.ai/ai/img_res/dc5ff3cb4c48d01dfd7665c269e98546.jpg',
    },
    {
      icon: 'ri-home-4-line',
      title: 'Exterior Painting',
      description: 'Protect your home from Michigan weather and keep it looking good. We paint siding, trim, doors, shutters, and more.',
      features: ['House siding and trim', 'Front and back doors', 'Window frames and shutters', 'Garage doors', 'Pressure washing and prep work', 'Paint that lasts through Michigan winters'],
      image: 'https://readdy.ai/api/search-image?query=painter%20on%20ladder%20painting%20house%20exterior%20siding%2C%20residential%20home%20exterior%20painting%20in%20progress%2C%20professional%20work%20setup%2C%20sunny%20day%2C%20simple%20clean%20background%20highlighting%20exterior%20painting%20service&width=800&height=600&seq=service-exterior-detail&orientation=landscape',
    },
    {
      icon: 'ri-door-line',
      title: 'Cabinet Painting',
      description: 'Want a new kitchen without the cost of new cabinets? Painting your cabinets gives you a fresh look for a lot less money.',
      features: ['Kitchen cabinets', 'Bathroom vanities', 'Built-in shelves and cabinets', 'Cabinet doors and drawer fronts', 'Smooth, durable finish', 'Looks like new cabinets'],
      image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20painter%20carefully%20painting%20kitchen%20cabinet%20doors%20with%20brush%2C%20professional%20cabinet%20refinishing%20work%2C%20white%20painted%20cabinets%2C%20detailed%20craftsmanship%2C%20simple%20clean%20background%20showing%20precision%20work&width=800&height=600&seq=service-cabinet-detail&orientation=landscape',
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Fence Painting & Staining',
      description: 'Keep your fence looking good and protected from weather. Staining or painting helps wood fences last longer.',
      features: ['Wood fence staining', 'Fence painting', 'Pressure washing before we start', 'Protects against rain and sun', 'Helps prevent cracking and fading', 'Natural or solid color finishes'],
      image: 'https://readdy.ai/api/search-image?query=professional%20painter%20staining%20wooden%20fence%20with%20brush%2C%20residential%20backyard%20fence%20staining%20project%2C%20natural%20wood%20tone%20finish%2C%20outdoor%20work%2C%20simple%20clean%20background%20showing%20fence%20restoration&width=800&height=600&seq=service-fence-detail&orientation=landscape',
    },
    {
      icon: 'ri-stack-line',
      title: 'Deck Staining',
      description: 'Regular deck staining protects your deck from sun, rain, and snow. It keeps the wood from cracking and helps it last longer.',
      features: ['Deck surface and railings', 'Cleaning and prep', 'Stain that protects from weather', 'Prevents wood damage', 'Natural wood look or solid colors', 'Helps your deck last years longer'],
      image: 'https://readdy.ai/api/search-image?query=painter%20applying%20stain%20to%20wooden%20deck%20with%20roller%2C%20residential%20deck%20staining%20project%20in%20progress%2C%20rich%20wood%20tone%2C%20outdoor%20setting%2C%20simple%20clean%20background%20showing%20deck%20refinishing%20work&width=800&height=600&seq=service-deck-detail&orientation=landscape',
    },
    {
      icon: 'ri-palette-line',
      title: 'Color Help',
      description: "Not sure what color to pick? We can help you choose colors that look good together and match your home.",
      features: ['Help picking colors', 'We can test samples first', 'Match colors to your furniture and floors', 'Advice on what looks good', 'Help choosing paint finish (flat, satin, etc.)', 'No extra charge for color help'],
      image: 'https://readdy.ai/api/search-image?query=paint%20color%20samples%20and%20swatches%20spread%20on%20table%2C%20color%20consultation%20setup%2C%20various%20paint%20chips%20and%20color%20cards%2C%20professional%20color%20selection%20process%2C%20simple%20clean%20background%20showing%20color%20planning&width=800&height=600&seq=service-color-detail&orientation=landscape',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <MobileCTA />

      {/* Hero Section */}
      <section className="pt-28 pb-12 bg-[#1A2B4A]">
        <div className="max-w-[1200px] mx-auto px-6 text-center">
          <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-3">Our Services</p>
          <h1 className="text-[44px] lg:text-[52px] font-extrabold text-white mb-4">
            Residential Painting Services
          </h1>
          <p className="text-[17px] text-white/70 max-w-[600px] mx-auto leading-relaxed">
            We handle all kinds of painting projects for homeowners in the Kalamazoo area.
          </p>
        </div>
      </section>

      {/* Services Detail Section */}
      <section className="py-12 bg-white">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="space-y-14">
            {services.map((service, index) => (
              <div
                key={index}
                className={`grid lg:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? '' : ''}`}
              >
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className="w-11 h-11 bg-[#1A2B4A] rounded-lg flex items-center justify-center mb-4">
                    <i className={`${service.icon} text-xl text-white`}></i>
                  </div>
                  <h2 className="text-[28px] lg:text-[32px] font-extrabold text-[#1A2B4A] mb-3">
                    {service.title}
                  </h2>
                  <p className="text-[15px] text-[#6B7280] leading-relaxed mb-5">
                    {service.description}
                  </p>
                  <ul className="grid grid-cols-2 gap-2 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-2">
                        <i className="ri-check-line text-[#10B981] text-base flex-shrink-0"></i>
                        <span className="text-[13px] text-[#6B7280]">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to="/contact"
                    className="inline-flex items-center bg-[#1A2B4A] text-white px-5 py-2.5 rounded-lg font-bold text-[14px] hover:bg-[#C8A96E] transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Get a Free Estimate
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                </div>
                <div className={`relative h-[320px] rounded-xl overflow-hidden ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 left-4 bg-[#1A2B4A] text-white px-3 py-1.5 rounded-lg">
                    <span className="text-[12px] font-bold">{service.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-12 bg-[#1A2B4A]">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center mb-10">
            <p className="text-[12px] text-[#C8A96E] uppercase tracking-widest font-bold mb-2">Simple Process</p>
            <h2 className="text-[34px] font-extrabold text-white mb-3">How It Works</h2>
            <p className="text-[16px] text-white/70">Getting your painting project done is easy</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { number: '01', title: 'Contact Us', description: 'Call, text, or fill out the form. We respond quickly.' },
              { number: '02', title: 'Free Estimate', description: 'We come look at your project and give you a clear price.' },
              { number: '03', title: 'Schedule the Work', description: 'Pick a time that works for you. We show up on time.' },
              { number: '04', title: 'Get It Done', description: 'We do the work, keep things clean, and finish the job right.' },
            ].map((step, index) => (
              <div key={index} className="bg-white/10 rounded-xl p-6 text-center">
                <div className="text-[40px] font-extrabold text-[#C8A96E] mb-3">{step.number}</div>
                <h3 className="text-[17px] font-bold text-white mb-2">{step.title}</h3>
                <p className="text-[13px] text-white/60 leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 bg-[#F8F7F5]">
        <div className="max-w-[800px] mx-auto px-6 text-center">
          <h2 className="text-[32px] lg:text-[38px] font-extrabold text-[#1A2B4A] mb-3">
            Ready to Get Started?
          </h2>
          <p className="text-[16px] text-[#6B7280] mb-7">
            Call or text us today for a free estimate
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="tel:+12695551234"
              className="w-full sm:w-auto bg-[#1A2B4A] text-white px-7 py-3.5 rounded-lg font-bold text-[15px] hover:bg-[#2A3B5A] transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2 text-lg"></i>
              (269) 555-1234
            </a>
            <Link
              to="/contact"
              className="w-full sm:w-auto bg-white border-2 border-[#1A2B4A] text-[#1A2B4A] px-7 py-3.5 rounded-lg font-bold text-[15px] hover:bg-[#1A2B4A] hover:text-white transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              Request Free Estimate
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
